import Select from "react-select";
import { Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";

const FilterSelect = ({
  title,
  items,
  value,
  onChange,
  grid = "col-12 col-sm-6 col-md-4 col-lg-3 col-xxl-2",
}) => {
  const [selected, setSelected] = useState({});

  useEffect(() => {
    setSelected(items?.find((obj) => value === obj.value));
  }, [value]);

  if (!items || !onChange) return null;

  return (
    <Col className={`${grid}`}>
      {title && (
        <label className="form-label" htmlFor="type">
          {title}
        </label>
      )}
      <div className="form-control-wrap">
        <Select
          openMenuOnFocus
          noOptionsMessage={() => <span>داده ای برای نمایش یافت نشد</span>}
          value={!isEmpty(selected) && selected}
          className="react-select-container"
          classNamePrefix="react-select"
          options={items}
          placeholder={title}
          onChange={(e) => onChange(e?.value)}
        />
      </div>
    </Col>
  );
};

export default FilterSelect;
